import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'separatorReplacer'
})
export class SeparatorReplacerPipe implements PipeTransform {

  transform(value: any, args: any = ''): any {
    return (value + '').replace(',', args);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/separator-replacer.pipe.ts